import { ButtonType,ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { ServerUrls } from '~src/app/ServerUrls';
import { Messages } from '~src/codegen/Localize';
import { BrowserTitleService } from '~src/commonInfra/services/BrowserTitleService';
import { CreateSiteAction } from '~src/ts/siteManagement/services/CreateSiteAction';

import { Location } from '../../../common/react/Location';


export function AddSiteSettingsSubspace() {
  BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverSettings_addSite()});
  const handleCreateSite = () => {
    new CreateSiteAction().execute()
      .then(() => {
        Location.instance.setUrl(ServerUrls.getInstance().sitesUrl());
      });
  };
  return (
    <div className={'tb-stylish-settings'}>
      <div className={'tb-tabs-banner-subplace'}>
        <div className={'tb-scroll'}>
          <div className={'tb-settings-container'}>
            <div className={'tb-settings-section'}>
              <div className={'tb-settings-title'}>
                {Messages.addSiteTitle()}
              </div>
              <div className={'tb-settings-group-name'}>
                {Messages.addSiteSubtitle()}
              </div>
              <div className={'tb-settings-msg'}>
                {Messages.addSiteDescription()}
              </div>
              <div className={'tb-settings-control'}>
                <ButtonWidget
                  testId={ 'add-new-site' }
                  buttonType={ ButtonType.Outline }
                  handleClick={ handleCreateSite }>
                  <span>{ Messages.addASite() }</span>
                </ButtonWidget>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
